import {
  VisionRoadmap,
  HeroRoadmap,
  FurtherRoadmap,
  RoadmapRoadmap,
  KeyPointsRoadmap,
  NewProductsRoadmap,
} from '~/sections/roadmap'

export default function Roadmap() {
  return (
    <div className="container">
      <HeroRoadmap />
      <VisionRoadmap />
      <RoadmapRoadmap />
      <KeyPointsRoadmap />
      <NewProductsRoadmap />
      <FurtherRoadmap />
    </div>
  )
}
